import { DeleteOutlined } from '@ant-design/icons'
import { Popconfirm } from 'antd'
import * as React from 'react'
import { GraviButton } from '@gravitate-js/excalibrr'
import type { DeleteRateButtonProps } from '../types'
import { useRateManagement } from '../hooks'

/**
 * Component for deleting a surcharge rate
 */
export function DeleteRateButton({ rate, surcharge, onSuccess }: DeleteRateButtonProps) {
  const { deleteRate } = useRateManagement(surcharge, onSuccess)

  /**
   * Handle deleting the rate
   */
  const handleDeleteRate = async () => {
    await deleteRate(rate)
  }

  return (
    <Popconfirm
      title='Delete Rate'
      description='Are you sure you want to delete this rate?'
      onConfirm={handleDeleteRate}
      okText='Yes'
      cancelText='No'
    >
      <GraviButton error icon={<DeleteOutlined />} />
    </Popconfirm>
  )
}
